import { render, staticRenderFns } from "./SubjectDetail2.vue?vue&type=template&id=6d420508&scoped=true&"
import script from "./SubjectDetail2.vue?vue&type=script&lang=js&"
export * from "./SubjectDetail2.vue?vue&type=script&lang=js&"
import style0 from "./SubjectDetail2.vue?vue&type=style&index=0&id=6d420508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d420508",
  null
  
)

export default component.exports